import axios from "axios";
import config from "../../config";
import { headers_get } from "../../main_components/tokens/get_headers_user";

const BASE_URL = `${config?.URL_SUPPORT}`;

const request = async (method, endpoint, data = null, params = null) => {
  // Verifica si el endpoint ya es una URL absoluta (http o https)
  const isAbsoluteUrl = /^https?:\/\//.test(endpoint);
  const url = isAbsoluteUrl ? endpoint : `${BASE_URL}/dev${endpoint}`;

  try {
    const headers = await headers_get();
    return await axios({ method, url, data, params, headers });
  } catch (error) {
    console.error(`Error in ${method.toUpperCase()} ${url}:`, error?.response?.data || error.message);
    throw error;
  }
};


// Consultar Soportes
export const get_supports = async () => request("get", "/supports");

// Crear Soporte
export const createSupport = async (data) => request("post", "/supports", data);

// Actualizar Soporte
export const updateSupport = async (id, data) => request("put", `/supports/${id}`, data);

export const reassignmentSupport = async (id, data) => request("post", `/supports/${id}/reassignment`, data);




// Consultar comentarios de un ticket
export const getComments = async (id) => request("get", `/supports/${id}/comments`, null, { ticket: id });

// Crear Comentario
export const createComment = async (id, data) => request("post", `/supports/${id}/comments`, data);

// Actualizar Comentario
export const updateComment = async (id, data) => request("put", `/supports/${id}/comments`, data);

// Subir imagen a un ticket
export const uploadimgticket = async (id, data) => request("post", `/supports/${id}/images`, data);

export const uploadimgticketprueba = async (id, data) => request("post", `/supports/${id}/images`, data);

// Obtener imagen de un ticket
export const getimgticket = async (id, name) => request("get", `/supports/${id}/images`, null, { image: name });

// Obtener secretos de Telegram
export const get_telegram_secrets = async () => request("get", "https://kyxq3rrh02.execute-api.us-east-1.amazonaws.com/dev/secret_telegram");

// Enviar mensaje de Telegram
export const post_telegram_msj = async (data) => request("post", "https://kyxq3rrh02.execute-api.us-east-1.amazonaws.com/dev/secret_telegram", data);


export const message_telegramjira_post = async (data) => request("post", "https://zi9r1sjy1f.execute-api.us-east-1.amazonaws.com/prod/message", data);





export const bot_telegram_get = async () =>
  request("get", "https://zi9r1sjy1f.execute-api.us-east-1.amazonaws.com/prod/user");

// Enviar datos al bot de Telegram (POST)
export const bot_telegram_post = async () =>
  request("post", "https://zi9r1sjy1f.execute-api.us-east-1.amazonaws.com/prod/user", {});
